import localizeCurrency from "@helpers/localizeCurrency"
import { getOnboardingContext } from "@helpers/localStorage"
import { PaymentIntent } from "@stripe/stripe-js"
import { Trans, useTranslation } from "react-i18next"
import { Plan } from "src/types"

interface TermsCheckboxProps {
  fullPrice: number
  isTermsAccepted: boolean
  paymentIntent: PaymentIntent | undefined
  plan: Plan
  setIsTermsAccepted: (isTermsAccepted: boolean) => void
}

export default function TermsCheckbox({
  fullPrice,
  isTermsAccepted,
  paymentIntent,
  plan,
  setIsTermsAccepted,
}: TermsCheckboxProps) {
  const { t } = useTranslation()
  const context = getOnboardingContext()
  const paymentCopyKey =
    context === "cars"
      ? "pages.checkout.paymentCars"
      : context === "pets"
        ? "pages.checkout.paymentPets"
        : "pages.checkout.payment"

  if (!paymentIntent) return null

  const labelKey =
    plan === "one-time"
      ? "termsCheckboxLabelOneTime"
      : plan === "weekly"
        ? "termsCheckboxLabelWeekly"
        : plan === "monthly"
          ? "termsCheckboxLabelMonthly"
          : plan === "quarterly"
            ? "termsCheckboxLabelQuarterly"
            : "termsCheckboxLabelYearly"

  const price = localizeCurrency({
    amountInCents: fullPrice,
    currency: paymentIntent.currency,
  })

  return (
    <div className="flex gap-2">
      <input
        checked={isTermsAccepted}
        className="mt-1 rounded-sm outline-hidden focus:ring-0 focus:ring-offset-0 focus:outline-hidden"
        id="terms-checkbox"
        onChange={(event) => setIsTermsAccepted(event.target.checked)}
        type="checkbox"
      />

      <label
        className="cursor-pointer text-xs leading-relaxed"
        htmlFor="terms-checkbox"
      >
        {t(`${paymentCopyKey}.${labelKey}`, { price })}{" "}
        <Trans
          components={{
            termsLink: (
              <a
                className="underline"
                href="https://www.filterly.app/terms"
                rel="noopener noreferrer"
                target="_blank"
              />
            ),
            privacyLink: (
              <a
                className="underline"
                href="https://www.filterly.app/privacy"
                rel="noopener noreferrer"
                target="_blank"
              />
            ),
          }}
          i18nKey={`${paymentCopyKey}.termsAcceptance`}
        />
      </label>
    </div>
  )
}
